import { neowiseToggleField } from './FmkCheckbox';
import { NwSwitch } from '@fafm/neowise-core';

export const FmkSwitch = neowiseToggleField(NwSwitch);
FmkSwitch.displayName = 'FmkSwitch';
